import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

import type { Crumb } from './page-chrome-context';

/** Una miga del topbar: enlace (con su `state`, si trae) o texto. */
export function CrumbLabel({ crumb }: { crumb: Crumb }): ReactElement {
  if (crumb.to) {
    return (
      <NavLink to={crumb.to} state={crumb.state}>
        {crumb.label}
      </NavLink>
    );
  }
  return crumb.strong ? <b>{crumb.label}</b> : <span>{crumb.label}</span>;
}
